import { GlBadge, GlLink, GlTooltipDirective, GlTruncate, GlIcon, GlHoverLoadDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { escapeRegExp } from 'lodash-es';
import SafeHtml from '~/vue_shared/directives/safe_html';
import paginatedTreeQuery from 'shared_queries/repository/paginated_tree.query.graphql';
import { buildURLwithRefType, joinPaths } from '~/lib/utils/url_utility';
import { TREE_PAGE_SIZE, ROW_APPEAR_DELAY } from '~/repository/constants';
import FileIcon from '../../../vue_shared/components/file_icon.vue?vue3';
import TimeagoTooltip from '../../../vue_shared/components/time_ago_tooltip.vue?vue3';
import blobInfoQuery from 'shared_queries/repository/blob_info.query.graphql';
import getRefMixin from '../../mixins/get_ref';
import { getRefType } from '../../utils/ref_type';
import SkeletonLoader from './skeleton_loader.vue';
export default {
    name: 'TableRow',
    components: {
        GlBadge,
        GlLink,
        SkeletonLoader,
        GlIcon,
        GlTruncate,
        TimeagoTooltip,
        FileIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        GlHoverLoad: GlHoverLoadDirective,
        SafeHtml
    },
    mixins: [
        getRefMixin
    ],
    inject: [
        'refType'
    ],
    inheritAttrs: false,
    props: {
        commitInfo: {
            type: Object,
            required: false,
            default: null
        },
        rowNumber: {
            type: Number,
            required: false,
            default: null
        },
        sha: {
            type: String,
            required: true
        },
        projectPath: {
            type: String,
            required: true
        },
        currentPath: {
            type: String,
            required: true
        },
        path: {
            type: String,
            required: true
        },
        mode: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: false,
            default: null
        },
        lfsOid: {
            type: String,
            required: false,
            default: null
        },
        submoduleTreeUrl: {
            type: String,
            required: false,
            default: null
        },
        loadingPath: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'row-appear'
    ],
    data () {
        return {
            delayedRowAppear: null,
            showCommitColumns: window.gon?.show_commit_columns !== false
        };
    },
    computed: {
        commitData () {
            return this.commitInfo;
        },
        routerLinkTo () {
            if (this.isBlob) {
                return buildURLwithRefType({
                    // eslint-disable-next-line @gitlab/no-hardcoded-urls -- This is a Vue router route defined in app/assets/javascripts/repository/router.js, acceptable in this case
                    path: joinPaths('/-/blob', this.escapedRef, encodeURI(this.path)),
                    refType: this.refType
                });
            }
            if (this.isFolder) {
                return buildURLwithRefType({
                    // eslint-disable-next-line @gitlab/no-hardcoded-urls -- This is a Vue router route defined in app/assets/javascripts/repository/router.js, acceptable in this case
                    path: joinPaths('/-/tree', this.escapedRef, encodeURI(this.path)),
                    refType: this.refType
                });
            }
            return null;
        },
        isBlob () {
            return this.type === 'blob';
        },
        isFolder () {
            return this.type === 'tree';
        },
        isSubmodule () {
            return this.type === 'commit';
        },
        nameCellComponent () {
            return this.showCommitColumns ? 'th' : 'td';
        },
        linkComponent () {
            return this.isFolder || this.isBlob ? 'router-link' : 'a';
        },
        fullPath () {
            return this.path.replace(new RegExp(`^${escapeRegExp(this.currentPath)}/`), '');
        },
        shortSha () {
            return this.sha.slice(0, 8);
        },
        hasLockLabel () {
            return this.commitData && this.commitData.lockLabel;
        },
        showSkeletonLoader () {
            return !this.commitData;
        }
    },
    mounted () {
        this.rowAppeared();
    },
    beforeDestroy () {
        clearTimeout(this.delayedRowAppear);
    },
    methods: {
        handlePreload () {
            return this.isFolder ? this.loadFolder() : this.loadBlob();
        },
        loadFolder () {
            this.apolloQuery(paginatedTreeQuery, {
                projectPath: this.projectPath,
                ref: this.ref,
                refType: getRefType(this.refType),
                path: this.path,
                nextPageCursor: '',
                pageSize: TREE_PAGE_SIZE
            });
        },
        loadBlob () {
            this.apolloQuery(blobInfoQuery, {
                projectPath: this.projectPath,
                filePath: [
                    this.path
                ],
                ref: this.ref,
                refType: getRefType(this.refType),
                shouldFetchRawText: true
            });
        },
        apolloQuery (query, variables) {
            this.$apollo.query({
                query,
                variables
            });
        },
        rowAppeared () {
            if (this.commitInfo) {
                return;
            }
            this.delayedRowAppear = setTimeout(()=>this.$emit('row-appear', this.rowNumber), ROW_APPEAR_DELAY);
        }
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'gl-emoji'
        ]
    }
};
